import React from 'react';
import * as toolSelectors from '../../../../selectors/tools';
import { useSelector } from 'react-redux';
import { ResultsColumn, ResultsColumnHeader, Row, HeaderRow, SubTitleText, Spreadsheet } from '../DTInfoWidget.styles';

const DTReturnPortalDetailsWidget = () => {
  const selectedOrderZipCode = useSelector(toolSelectors.getBillingZipCodeOfSelectedOrder);
  const selectedOrderEmail = useSelector(toolSelectors.getEmailOfSelectedOrder);
  const selectedOrderName = useSelector(toolSelectors.getSelectedOrderName);

  // used bby Steve Madden - do not use for other partners
  return (
    <Spreadsheet className="fs-block">
      <SubTitleText>ORDER INFORMATION</SubTitleText>
      <HeaderRow>
        <ResultsColumnHeader>EMAIL</ResultsColumnHeader>
        <ResultsColumnHeader>ORDER ID</ResultsColumnHeader>
        <ResultsColumnHeader>ZIP CODE</ResultsColumnHeader>
      </HeaderRow>
      <Row>
        <ResultsColumn>{selectedOrderEmail}</ResultsColumn>
        <ResultsColumn>{selectedOrderName}</ResultsColumn>
        <ResultsColumn>{selectedOrderZipCode}</ResultsColumn>
      </Row>
    </Spreadsheet>
  );
};
export default DTReturnPortalDetailsWidget;
